function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a3021e;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M-38.4,390.543l7.025-5.678c.585-1.175-1.472-1.908-2.281-1.752a1.41,1.41,0,0,0-.643.309l-7.283,5.184c-.433.326-1.379.931-1.19,1.344.575,1.254,3.926.443,3-.989-.5-.778-.261-.948-.775-1.917a2.624,2.624,0,0,0-3.361-1.154,5.049,5.049,0,0,0-2.878,2.226c-4.631,7.5-8.585,8.718-8.585,8.718-5.126,2.33-14.964-.585-14.964-.585s-1.965-.511-.194,3c1.276,2.528,7.085,5.365,13.282,4.953,10.076-.669,14.455-4.782,18.381-7.778A12.416,12.416,0,0,0-37.38,395.1a2.542,2.542,0,0,0-.968-4.248A.18.18,0,0,1-38.4,390.543Z",
  transform: "translate(71.274 -383.092)"
});

function SvgChilli(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 21.148,
    viewBox: "0 0 40 21.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChilli);
export default __webpack_public_path__ + "static/media/chilli.fbf92395.svg";
export { ForwardRef as ReactComponent };